<template>
    <div class="pagination-wrap">
        <button class="page-arrow" :disabled="currentPage <= 1" @click="currentPage > 1 && $emit('paginate', currentPage - 1)">
            <ChevronLeftIcon class="h-4 w-4" />
        </button>

        <template v-for="page in visiblePages" :key="page">
            <span v-if="page === '...'" class="page-ellipsis">…</span>
            <button v-else class="page-btn" :class="{ 'page-btn-active': page === currentPage }"
                @click="$emit('paginate', page)">
                {{ page }}
            </button>
        </template>

        <button class="page-arrow" :disabled="currentPage >= totalPages"
            @click="currentPage < totalPages && $emit('paginate', currentPage + 1)">
            <ChevronRightIcon class="h-4 w-4" />
        </button>
    </div>
</template>

<script>
import { computed } from "vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/outline";

export default {
    name: "Pagination",
    props: {
        total: { type: Number, default: 1 },
        active: { type: Number, default: 1 },
    },
    emits: ["paginate"],
    components: { ChevronLeftIcon, ChevronRightIcon },
    setup(props) {
        const totalPages = computed(() => props.total || 1);
        const currentPage = computed(() => props.active || 1);

        const visiblePages = computed(() => {
            const total = totalPages.value;
            const current = currentPage.value;
            if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

            const pages = [];
            if (current <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(i);
                pages.push("...");
                pages.push(total);
            } else if (current >= total - 3) {
                pages.push(1);
                pages.push("...");
                for (let i = total - 4; i <= total; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push("...");
                for (let i = current - 1; i <= current + 1; i++) pages.push(i);
                pages.push("...");
                pages.push(total);
            }
            return pages;
        });

        return { totalPages, currentPage, visiblePages };
    },
};
</script>

<style lang="scss" scoped>
.pagination-wrap {
    @apply inline-flex items-center gap-1;
}

.page-arrow {
    @apply flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition-colors hover:bg-gray-50;

    &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
}

.page-btn {
    @apply flex h-8 w-8 items-center justify-center rounded-lg text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100;
}

.page-btn-active {
    @apply bg-gray-900 text-white hover:bg-gray-800;
}

.page-ellipsis {
    @apply flex h-8 w-8 items-center justify-center text-sm text-gray-400;
}
</style>
